import Velocity from 'velocity-animate';

class scrollLock
{
    started = false;

    _beforeEachHooks = [];

    $state = {
        index: 0,
        transitioning: false,
        pause: false,
        shifted: false,
        shiftedLock: false,
        shiftedWait: false,
        isMobile: false,
        mobileThreshold: 15,
        slidesIsActive: false
    };

    _listens = null;

    constructor(elements, slider, options = {})
    {
        this.elements = elements;
        this.slider = slider;

        this.options = Object.assign({
            threshold: 30,
            wait: 650
        }, options);

		if(window.navigator.appVersion.toLowerCase().indexOf('windows') > -1 && window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        	this.options.threshold = 2;
    	}
    }

    go(to)
    {
        return new Promise((resolve, reject) => {
            if (to > -1 && to < this.elements.length) {
                this.handleBeforeCallbacks(to, () => {
                    this.$state.index = to;
                    this.scroll(this.elements[to]).then(() => {
                        resolve();
                    }).catch(() => {
                        // reject();
                    });
                });
            }
        });
    }

    scroll(element)
    {
        return new Promise((resolve, reject) => {
            this.$state.transitioning = true;

            new Velocity(document.body, 'scroll', {
                offset: element.offsetTop,
                complete: () => {
                    resolve();

                    this.handleIfIsSlides(element);
                    this.handleIfIsShifted(element);

                    setTimeout(() => {
                        this.$state.transitioning = false;
                    }, this.options.wait);
                }
            });
        });
    }

    animateScroll(element)
    {
        return new Velocity(document.body, 'scroll', {
            offset: element.offsetTop,
        }, 100);
    }

    handleIfIsSlides(element)
    {
        if (! element.classList.contains('landingpage__slides')) {
            return false;
        }

        this.pause();
        this.$state.slidesIsActive = true;

        setTimeout(() => {
            this.slider.listen();

            this.slider.on('done', (direction) => {

                this.slider.pause();

                if(direction == 'up') {
                    this.go(this.$state.index-1);
                } else {
                    this.go(this.$state.index+1);
                }

                this.$state.slidesIsActive = false;
                this.start();
            });
        }, this.options.wait);
    }

    handleIfIsShifted(element)
    {
        if (! element.classList.contains('shift')) {
            document.body.classList.remove('shifted');
            return false;
        }

        this.pause();
        this.$state.shifted = true;
        document.body.classList.add('shifted');

        if (this.$state.isMobile) {
            this.handleMobileShiftedScroll();
        }
    }

    handleMobileShiftedScroll()
    {
        let shiftedElement = this.elements[this.$state.index];

        window.addEventListener('scroll', (e) => {
            if (this.$state.slidesIsActive || ! this.$state.pause) {
                return true;
            }

            console.log('[SCROLL]', this.scrollY(), shiftedElement.offsetTop  - this.$state.mobileThreshold);

            if(this.scrollY() <= shiftedElement.offsetTop - this.$state.mobileThreshold) {
                this.$state.shiftedLock = false;
                this.$state.shifted = false;
                this.$state.pause = false;

                document.body.classList.remove('shifted');

                this.go(this.$state.index - 1);
                this.start();
            }
        });
    }

    handleShiftedScroll(e)
    {
        let shiftedElement = this.elements[this.$state.index];

        if(this.$state.shiftedWait) {
            return;
        }

        if(! this.$state.shiftedLock && this.scrollY() < shiftedElement.offsetTop) {
            this.$state.shiftedLock = true;
            this.$state.shiftedWait = true;

            document.body.classList.remove('shifted');
            this.animateScroll(shiftedElement);

            setTimeout(() => {
                this.$state.shiftedWait = false;
            }, this.options.wait);
        }
        else if(this.$state.shiftedLock && e.deltaY > 0) {
            this.$state.shiftedLock = false;
            document.body.classList.add('shifted');
        }
        else if(this.$state.shiftedLock && e.deltaY < (Math.abs(this.options.threshold) * -1)) {
            this.$state.shiftedLock = false;
            this.$state.shifted = false;

            this.go(this.$state.index - 1);
        }
    }

    scrollY()
    {
        return typeof window.scrollY !== 'undefined' ? window.scrollY : document.documentElement.scrollTop;
    }

    start()
    {
        this.$state.pause = false;

        if (! this.started) {
            this.started = true;
            this.listen();
        }

        return this;
    }

    pause()
    {
        this.$state.pause = true;
    }

    handleBeforeCallbacks(toIndex, next)
    {
        if (this._beforeEachHooks.length) {
            this._beforeEachHooks.forEach((hook, index) => {
                return hook({
                    from: {index: this.$state.index, element: this.elements[this.$state.index - 1]},
                    to: {index: toIndex, element: this.elements[toIndex]}
                }, (cb) => {
                    if(index + 1 === this._beforeEachHooks.length) {
                        return next();
                    }

                    return true;
                });
            });
        } else {
            next();
        }
    }

    beforeEach(cb)
    {
        this._beforeEachHooks.push(cb);
    }

    listen()
    {
        if (this._listens) {
            return;
        }

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            this._setupMobileListener();
        } else {
            this._setupBrowserListener();
        }

        this._listens = true;
    }

    _setupMobileListener()
    {
        this.$state.isMobile = true;

        let manager = new Hammer.Manager(this.elements[0]);
        manager.add(new Hammer.Swipe({event: 'animateSite', direction: Hammer.DIRECTION_VERTICAL}));

        manager.on('animateSite', (e) => {
            let index;

            if (this.$state.pause || this.$state.transitioning) {
                return false;
            }

            if(e.direction == Hammer.DIRECTION_DOWN) {
                index = this.$state.index + -1;
            } else {
                index = this.$state.index + 1;
            }

            this.go(index);
        });
    }

    _setupBrowserListener()
    {
        window.addEventListener('wheel', (e) => {
            if(this.$state.shifted || this.$state.shiftedLock) {
                return this.handleShiftedScroll(e);
            }

            if (this.$state.pause || this.$state.transitioning) {
                return false;
            }

            if (e.deltaY >= this.options.threshold) {
                this.go(this.$state.index + 1);
            } else if (e.deltaY <= Math.abs(this.options.threshold) * -1) {
                this.go(this.$state.index - 1);
            }
        });
    }

    resetShift()
    {
        this.$state.shifted = false;
        this.$state.shiftedLock = false;
        this.$state.shiftedWait = false;

        document.body.classList.remove('shifted');
    }
}

export default scrollLock;
